import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, LayoutTemplate, Euro } from 'lucide-react';
export function Solutions() {
  return <section className="py-24 bg-dark-lighter relative overflow-hidden" id="platform" data-id="element-238">
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-239" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-240">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-241">
          <h2 className="font-rajdhani text-4xl md:text-6xl font-bold mb-6" data-id="element-242">
            PIXELKEEP{' '}
            <span className="text-neon-cyan text-glow-cyan" data-id="element-243">
              CHANGES THE GAME
            </span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-244">
            A purpose-built ecosystem designed to make esports sponsorships
            transparent, efficient, and scalable.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-245">
          {/* Feature 1: Smart Matching Engine */}
          <div className="flex flex-col justify-center" data-id="element-246">
            <div className="flex items-center gap-3 mb-4" data-id="element-247">
              <Zap className="text-neon-cyan w-6 h-6" data-id="element-248" />
              <h3 className="font-rajdhani text-3xl font-bold" data-id="element-249">
                Smart Matching Engine
              </h3>
            </div>
            <p className="text-gray-400 mb-8" data-id="element-250">
              Our algorithm pairs teams and brands based on budget, audience
              demographics, and game titles. No more guessing—just perfect
              synergy.
            </p>

            {/* Bracket Graphic Mockup */}
            <div className="bg-dark p-6 rounded-xl border border-white/10 relative h-64 flex items-center justify-between overflow-hidden" data-id="element-251">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,243,255,0.1)_0%,transparent_70%)]" data-id="element-252" />

              {/* Left: Teams */}
              <div className="flex flex-col gap-4 z-10" data-id="element-253">
                <div className="px-4 py-2 bg-dark-card border border-white/10 rounded text-sm font-bold" data-id="element-254">
                  Void Serpents
                </div>
                <div className="px-4 py-2 bg-dark-card border border-white/10 rounded text-sm font-bold" data-id="element-255">
                  Neon Wraiths
                </div>
              </div>

              {/* Center Match */}
              <div className="relative z-10 flex flex-col items-center" data-id="element-256">
                <div className="w-12 h-12 rounded-full bg-neon-cyan/20 border border-neon-cyan flex items-center justify-center glow-cyan mb-2" data-id="element-257">
                  <Zap className="w-5 h-5 text-neon-cyan" data-id="element-258" />
                </div>
                <span className="text-xs font-bold text-neon-cyan tracking-widest uppercase" data-id="element-259">
                  Match Found
                </span>
              </div>

              {/* Right: Brands */}
              <div className="flex flex-col gap-4 z-10" data-id="element-260">
                <div className="px-4 py-2 bg-dark-card border border-white/10 rounded text-sm font-bold" data-id="element-261">
                  Voltarc Peripherals
                </div>
                <div className="px-4 py-2 bg-dark-card border border-white/10 rounded text-sm font-bold" data-id="element-262">
                  Cryoshift Energy
                </div>
              </div>

              {/* Connecting Lines (SVG) */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
              zIndex: 0
            }} data-id="element-263">
                <path d="M 120 70 L 180 70 L 180 128 L 240 128" stroke="rgba(255,255,255,0.2)" strokeWidth="2" fill="none" data-id="element-264" />
                <path d="M 120 186 L 180 186 L 180 128" stroke="rgba(255,255,255,0.2)" strokeWidth="2" fill="none" data-id="element-265" />
                <path d="M 450 70 L 390 70 L 390 128 L 330 128" stroke="rgba(255,255,255,0.2)" strokeWidth="2" fill="none" data-id="element-266" />
                <path d="M 450 186 L 390 186 L 390 128" stroke="rgba(255,255,255,0.2)" strokeWidth="2" fill="none" data-id="element-267" />
              </svg>
            </div>
          </div>

          {/* Feature 2: Verified Analytics */}
          <div className="flex flex-col justify-center lg:order-last" data-id="element-268">
            <div className="flex items-center gap-3 mb-4" data-id="element-269">
              <CheckCircle2 className="text-neon-lime w-6 h-6" data-id="element-270" />
              <h3 className="font-rajdhani text-3xl font-bold" data-id="element-271">
                Verified Team Analytics
              </h3>
            </div>
            <p className="text-gray-400 mb-8" data-id="element-272">
              API integrations with Twitch, YouTube, and major tournament
              organizers ensure all team stats are 100% accurate and up-to-date.
            </p>

            {/* Roster Card Mockup */}
            <div className="bg-dark p-6 rounded-xl border border-white/10 flex justify-center" data-id="element-273">
              <div className="w-64 bg-dark-card border border-neon-lime/30 rounded-lg overflow-hidden shadow-[0_0_20px_rgba(57,255,20,0.15)]" data-id="element-274">
                <div className="h-32 bg-gradient-to-br from-dark to-neon-lime/20 relative" data-id="element-275">
                  <div className="absolute bottom-2 left-2 bg-dark/80 backdrop-blur px-2 py-1 rounded text-xs font-bold border border-white/10" data-id="element-276">
                    FPS / TACTICAL
                  </div>
                </div>
                <div className="p-4" data-id="element-277">
                  <h4 className="font-rajdhani text-xl font-bold mb-1" data-id="element-278">
                    Void Serpents
                  </h4>
                  <p className="text-xs text-gray-400 mb-4" data-id="element-279">Limassol, Cyprus</p>
                  <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-280">
                    <div className="bg-dark p-2 rounded border border-white/5" data-id="element-281">
                      <div className="text-gray-500 text-xs" data-id="element-282">Avg Viewers</div>
                      <div className="font-bold text-neon-lime" data-id="element-283">45.2K</div>
                    </div>
                    <div className="bg-dark p-2 rounded border border-white/5" data-id="element-284">
                      <div className="text-gray-500 text-xs" data-id="element-285">Win Rate</div>
                      <div className="font-bold text-white" data-id="element-286">68%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Feature 3: Jersey Builder */}
          <div className="flex flex-col justify-center" data-id="element-287">
            <div className="flex items-center gap-3 mb-4" data-id="element-288">
              <LayoutTemplate className="text-neon-magenta w-6 h-6" data-id="element-289" />
              <h3 className="font-rajdhani text-3xl font-bold" data-id="element-290">
                Jersey Sponsor Builder
              </h3>
            </div>
            <p className="text-gray-400 mb-8" data-id="element-291">
              Brands can visually test their logos on team kits before signing.
              Drag, drop, and preview placements in real-time.
            </p>

            {/* Jersey Builder Mockup */}
            <div className="bg-dark p-6 rounded-xl border border-white/10 flex gap-6" data-id="element-292">
              <div className="flex-1 relative bg-dark-card rounded-lg border border-white/5 flex items-center justify-center p-4" data-id="element-293">
                {/* Abstract T-Shirt Shape */}
                <svg viewBox="0 0 200 200" className="w-full h-48 text-dark-lighter drop-shadow-xl" data-id="element-294">
                  <path d="M 50 20 Q 100 40 150 20 L 190 60 L 160 90 L 150 70 L 150 180 L 50 180 L 50 70 L 40 90 L 10 60 Z" fill="currentColor" stroke="rgba(255,255,255,0.1)" strokeWidth="2" data-id="element-295" />
                </svg>
                {/* Placement Zones */}
                <div className="absolute top-[40%] left-1/2 -translate-x-1/2 w-16 h-8 border-2 border-dashed border-neon-magenta/50 rounded flex items-center justify-center bg-neon-magenta/10" data-id="element-296">
                  <span className="text-[8px] font-bold text-neon-magenta" data-id="element-297">
                    CHEST
                  </span>
                </div>
                <div className="absolute top-[35%] right-[20%] w-8 h-10 border-2 border-dashed border-white/20 rounded flex items-center justify-center" data-id="element-298">
                  <span className="text-[6px] font-bold text-gray-500 rotate-90" data-id="element-299">
                    SLEEVE
                  </span>
                </div>
              </div>
              <div className="w-1/3 flex flex-col gap-3" data-id="element-300">
                <div className="text-xs font-bold text-gray-400 uppercase" data-id="element-301">
                  Assets
                </div>
                <div className="bg-dark-card border border-neon-magenta/30 p-2 rounded flex items-center justify-center h-12 cursor-pointer" data-id="element-302">
                  <span className="font-rajdhani font-bold text-sm" data-id="element-303">
                    VOLTARC
                  </span>
                </div>
                <div className="bg-dark-card border border-white/10 p-2 rounded flex items-center justify-center h-12 opacity-50" data-id="element-304">
                  <span className="font-rajdhani font-bold text-sm" data-id="element-305">
                    CRYOSHIFT
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Feature 4: Transparent Terms */}
          <div className="flex flex-col justify-center" data-id="element-306">
            <div className="flex items-center gap-3 mb-4" data-id="element-307">
              <Euro className="text-white w-6 h-6" data-id="element-308" />
              <h3 className="font-rajdhani text-3xl font-bold" data-id="element-309">
                Transparent Deal Terms
              </h3>
            </div>
            <p className="text-gray-400 mb-8" data-id="element-310">
              Standardized pricing models based on market data. Know exactly
              what a chest logo or social media shoutout is worth.
            </p>

            {/* Pricing Cards Mockup */}
            <div className="bg-dark p-6 rounded-xl border border-white/10 flex flex-col gap-3" data-id="element-311">
              <div className="flex items-center justify-between p-4 bg-dark-card border border-white/5 rounded-lg" data-id="element-312">
                <div className="flex items-center gap-3" data-id="element-313">
                  <div className="w-2 h-2 rounded-full bg-neon-cyan" data-id="element-314" />
                  <span className="font-medium" data-id="element-315">Primary Chest Logo</span>
                </div>
                <span className="font-rajdhani font-bold text-xl" data-id="element-316">
                  €2,500<span className="text-sm text-gray-500" data-id="element-317">/mo</span>
                </span>
              </div>
              <div className="flex items-center justify-between p-4 bg-dark-card border border-white/5 rounded-lg" data-id="element-318">
                <div className="flex items-center gap-3" data-id="element-319">
                  <div className="w-2 h-2 rounded-full bg-neon-magenta" data-id="element-320" />
                  <span className="font-medium" data-id="element-321">Right Sleeve Logo</span>
                </div>
                <span className="font-rajdhani font-bold text-xl" data-id="element-322">
                  €800<span className="text-sm text-gray-500" data-id="element-323">/mo</span>
                </span>
              </div>
              <div className="flex items-center justify-between p-4 bg-dark-card border border-white/5 rounded-lg" data-id="element-324">
                <div className="flex items-center gap-3" data-id="element-325">
                  <div className="w-2 h-2 rounded-full bg-neon-lime" data-id="element-326" />
                  <span className="font-medium" data-id="element-327">Social Media Package</span>
                </div>
                <span className="font-rajdhani font-bold text-xl" data-id="element-328">
                  €1,200<span className="text-sm text-gray-500" data-id="element-329">/mo</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}